// assets
import { NavItemType } from 'types';
import SvgIcon from '@mui/material/SvgIcon';
import priorityLogo from 'assets/images/priority/PriorityLetterLogo.png';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import WebhookOutlinedIcon from '@mui/icons-material/WebhookOutlined';
import { IconAddressBook, IconBrandChrome, IconRobotFace, IconTemplate, IconSend } from '@tabler/icons-react';
import LabelOutlined from '@mui/icons-material/LabelOutlined';
import { getImageUrl } from 'utils/getImageUrl';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import DrawOutlinedIcon from '@mui/icons-material/DrawOutlined';

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages: NavItemType = {
  id: 'pages',
  title: 'pages',
  caption: 'pages-caption',
  type: 'group',
  children: [
    // Section 1 - שימוש מתקדם
    {
      id: 'section-1',
      type: 'group',
      title: 'settingsPopup.navigation.constantUse.label',
      customPage: true,
      children: [
        {
          id: 'calendar',
          url: '/calendar',
          title: 'header.megamenu.calendar.title',
          caption: 'header.megamenu.calendar.caption',
          icon: <EventOutlinedIcon />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'broadcasts',
          url: '/broadcasts/planned',
          title: 'header.megamenu.broadcasts.title',
          caption: 'header.megamenu.broadcasts.caption',
          icon: <IconSend />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'workflows',
          url: '/workflows',
          title: 'header.megamenu.workflows.title',
          caption: 'header.megamenu.workflows.caption',
          icon: <IconRobotFace />,
          type: 'item',
        },
        {
          id: 'docs-sign',
          url: '#',
          title: 'החתמה על מסמכים',
          caption: 'ניהול מסמכים שנחתמו והגדרות החתמות וחתימות',
          icon: <DrawOutlinedIcon />,
          type: 'item',
        },
      ],
    },
    // Section 2 - ניהול המערכת
    {
      id: 'section-2',
      type: 'group',
      title: 'settingsPopup.navigation.systemManagement.label',
      customPage: true,
      children: [
        {
          id: 'app-users',
          url: '/users',
          title: 'header.megamenu.app-users.title',
          caption: 'header.megamenu.app-users.caption',
          icon: <GroupOutlined />,
          type: 'item',
        },
        {
          id: 'templates',
          url: '/templates/list',
          title: 'header.megamenu.templates.title',
          caption: 'header.megamenu.templates.caption',
          icon: <IconTemplate />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'labels',
          url: '/labels',
          title: 'header.megamenu.labels.title',
          caption: 'header.megamenu.labels.caption',
          icon: <LabelOutlined />,
          type: 'item',
        },
        {
          id: 'drive',
          url: '/drive/images',
          title: 'header.megamenu.files.title',
          caption: 'header.megamenu.files.caption',
          icon: <FolderOpenOutlinedIcon />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'AISupport',
          url: '/ai-support',
          title: 'header.megamenu.ai.title',
          caption: 'header.megamenu.ai.caption',
          icon: <AutoAwesomeOutlinedIcon />,
          type: 'item',
        },
        {
          id: 'statistics',
          url: '/statistics',
          title: 'header.megamenu.statistics.title',
          caption: 'header.megamenu.statistics.caption',
          icon: <AssessmentOutlinedIcon />,
          type: 'item',
        },
      ],
    },
    // Section 3 - הגדרות
    {
      id: 'section-3',
      type: 'group',
      title: 'settingsPopup.navigation.systemSettings.label',
      customPage: true,
      children: [
        {
          id: 'webhooks',
          url: '/webhooks',
          title: 'header.megamenu.webhooks.title',
          caption: 'header.megamenu.webhooks.caption',
          icon: <WebhookOutlinedIcon />,
          type: 'item',
        },
        {
          id: 'prioritySync',
          url: '/priority',
          title: 'header.megamenu.prioritySync.title',
          caption: 'header.megamenu.prioritySync.caption',
          icon: <img src={priorityLogo} alt="priority" style={{ width: 24, height: 24 }} />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'fireberrySync',
          url: '/fireberry',
          title: 'header.megamenu.fireberrySync.title',
          caption: 'header.megamenu.fireberrySync.caption',
          icon: (
            <SvgIcon>
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.0468 8.45601C11.0451 8.43943 11.042 8.42344 11.0397 8.40709C11.0369 8.38746 11.0346 8.36797 11.0308 8.34857C11.0271 8.32986 11.022 8.31182 11.0174 8.29356C11.0131 8.27676 11.0094 8.25984 11.0044 8.24316C10.9989 8.22524 10.9922 8.20787 10.9859 8.19029C10.9799 8.17361 10.9745 8.15691 10.9677 8.14056C10.9609 8.12411 10.9529 8.10843 10.9453 8.09242C10.9374 8.07553 10.9299 8.05862 10.9211 8.04204C10.9129 8.0267 10.9034 8.01205 10.8945 7.99706C10.8849 7.98092 10.8758 7.96458 10.8652 7.94892C10.8541 7.93234 10.8418 7.91666 10.8298 7.90078C10.8201 7.8877 10.811 7.87428 10.8006 7.86153C10.7541 7.80494 10.7022 7.75297 10.6455 7.70652C10.6328 7.69616 10.6194 7.68701 10.6063 7.67722C10.5904 7.66537 10.5749 7.65298 10.5583 7.64193C10.5426 7.63144 10.5262 7.62231 10.5101 7.61261C10.4951 7.60371 10.4805 7.59423 10.465 7.586C10.4486 7.57721 10.4317 7.56978 10.415 7.56189C10.3989 7.55433 10.3831 7.54632 10.3666 7.53945C10.3502 7.53267 10.3335 7.52727 10.3169 7.52129C10.2993 7.51498 10.282 7.50822 10.264 7.5027C10.2473 7.49774 10.2305 7.49401 10.2137 7.48984C10.1953 7.48522 10.1773 7.48003 10.1586 7.4763C10.1392 7.47247 10.1197 7.47021 10.1003 7.46741C10.0839 7.46515 10.0677 7.46199 10.0511 7.46042C10.0147 7.4568 9.97809 7.45478 9.94155 7.45478H7.34705L10.7302 4.07159C11.164 3.63788 11.164 2.9345 10.7303 2.5008C10.2965 2.06697 9.59318 2.06697 9.15938 2.5008L3.87998 7.78013C3.44622 8.21396 3.44622 8.91724 3.87998 9.35105C4.09688 9.56795 4.38114 9.67641 4.66541 9.67641H7.25993L6.51805 10.4182C6.08425 10.8521 6.08425 11.5553 6.51805 11.9892L9.15612 14.6271C9.35714 14.8282 9.6348 14.9525 9.94155 14.9525C10.555 14.9525 11.0523 14.4552 11.0523 13.8417C11.0523 13.535 10.928 13.2573 10.727 13.0563L8.87432 11.2037L10.727 9.35105C10.7528 9.32511 10.7774 9.29795 10.8006 9.26954C10.811 9.25692 10.8201 9.2435 10.8299 9.23042C10.8418 9.21452 10.8541 9.19896 10.8652 9.18239C10.8757 9.16661 10.8849 9.15026 10.8945 9.13414C10.9035 9.11915 10.9129 9.10448 10.9211 9.08904C10.9299 9.07269 10.9373 9.05578 10.9452 9.03899C10.9528 9.02298 10.9609 9.00709 10.9677 8.99062C10.9745 8.97427 10.9799 8.95759 10.9859 8.94101C10.9922 8.92343 10.9989 8.90606 11.0044 8.88804C11.0094 8.87146 11.0131 8.85455 11.0173 8.83774C11.0219 8.81937 11.0271 8.80134 11.0308 8.78261C11.0346 8.76333 11.0369 8.74372 11.0397 8.72434C11.042 8.70787 11.0451 8.69175 11.0468 8.67517C11.0504 8.63875 11.0523 8.60223 11.0523 8.56571V8.5656C11.0523 8.52907 11.0504 8.49243 11.0468 8.45601ZM17 8.5C17 13.1944 13.1944 17 8.5 17C3.80557 17 0 13.1944 0 8.5C0 3.80557 3.80557 0 8.5 0C13.1944 0 17 3.80557 17 8.5Z"
                  fill="currentColor"
                />
              </svg>
            </SvgIcon>
          ),
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'extension',
          url: '/company/extensions',
          title: 'תוסף לדפדפן',
          caption: 'הגדרת הצגת חלון שיחה באתרים שונים וזיהוי מספרי טלפון',
          icon: <IconBrandChrome />,
          type: 'item',
        },
        {
          id: 'data-export',
          url: '#',
          title: 'ייצוא נתונים',
          caption: 'ייצוא כלל המידע מהמערכת',
          icon: <DownloadForOfflineOutlinedIcon />,
          type: 'item',
        },
      ],
    },
  ],
};

export default pages;
